export default __webpack_public_path__ + "static/bunfestival-5-2370dbaa1374bc4eba49b06da1ad7d6f.png";